import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "@vilocnv/allsetra-core";
import i18n from "i18next";
import { unblockKey } from "domain/keys/api/unblock-key";
import { KeyActionRequestDto } from "domain/keys/entities/dtos/key-action-request.dto";

const unblockKeyAction = createAsyncThunk(
  "keys/unblockKeyAction",
  async (request: KeyActionRequestDto, thunkAPI) => {
    try {
      return await unblockKey(request);
    } catch (error: any) {
      console.error(error);
      toast.error(i18n.t("toasts.unblockKeyError"));
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export default unblockKeyAction;
